import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { DayReflection } from '../../types/reflection.js';

@customElement('cp-reflection-list')
export class CpReflectionList extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) notes: DayReflection[] = [];
  @property({ type: Boolean }) expanded = false;

  private _formatRelativeTime(iso: string): string {
    const diff = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'gerade eben';
    if (mins < 60) return `vor ${mins} Min.`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `vor ${hours} Std.`;
    const days = Math.floor(hours / 24);
    return `vor ${days} Tag${days > 1 ? 'en' : ''}`;
  }

  private _renderNote(note: DayReflection) {
    const isProcessed = note.processed === 1;

    return html`
      <div class="cp-reflection-list__item ${isProcessed ? 'cp-reflection-list__item--processed' : ''}">
        <div class="cp-reflection-list__item-header">
          ${isProcessed
            ? html`<svg class="cp-reflection-list__check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`
            : html`<span class="cp-reflection-list__dot"></span>`
          }
          <span class="cp-reflection-list__time">${this._formatRelativeTime(note.created_at)}</span>
          ${note.tag ? html`<span class="cp-reflection-list__tag">${note.tag}</span>` : nothing}
        </div>
        <p class="cp-reflection-list__text">${note.text}</p>
      </div>
    `;
  }

  render() {
    if (!this.expanded) return nothing;

    if (this.notes.length === 0) {
      return html`
        <div class="cp-reflection-list__empty">
          Keine Notizen vorhanden
        </div>
      `;
    }

    return html`
      <div class="cp-reflection-list">
        ${this.notes.map(note => this._renderNote(note))}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-reflection-list': CpReflectionList;
  }
}
